var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33341 2.66663L10.8601 4.19329L8.94008 6.11329L9.88675 7.05996L11.8067 5.13996L13.3334 6.66663V2.66663H9.33341ZM6.66675 2.66663H2.66675V6.66663L4.19341 5.13996L7.33341 8.27329V13.3333H8.66675V7.72663L5.14008 4.19329L6.66675 2.66663Z",
    fill: "#3A4458"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSplit);
export default __webpack_public_path__ + "static/media/arrow-split.7b7dcacb.svg";
export { ForwardRef as ReactComponent };